import axios from "axios";
import React, { useEffect, useState } from "react";
import FadeIn from "react-fade-in/lib/FadeIn";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Toast,
  ToastBody,
} from "reactstrap";
import { GetCookieToken } from "../../../Cookie/GetCookie";
import LoadingData from "../../../TESTPage/LoadingData";
import Breadcrumb from "../../../../components/Common/Breadcrumb";
import SubMenuLeave from "../../SubMenuLeaveOnline";
import ModalUser from "../../../SetData/SetCommander/ModalUser";

const Menu1 = ({ menu }) => {
  const baseURL = process.env.REACT_APP_API_CORS;
  const token = GetCookieToken("userToken");

  const [data, setData] = useState([]);
  const [budgetYearData, setBudgetYearData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [budgetYear, setBudgetYear] = useState();
  const [successAdd, setSuccessAdd] = useState(false)
  const [failAdd, setFailAdd] = useState(false)
  const [userName, setUserName] = useState(null);

  const getLeaveSetting = async () => {
    try {
      const url = baseURL + "/api/leaveSetting/datatable";
      const params = new URLSearchParams({
        page: 1,
        size: 10,
        "order[0]": "budget_year",
        "order[1]": "DESC",
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      setData(res?.data?.result);
      setBudgetYear(res?.data?.result[0]?.budget_year);
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    getLeaveSetting();
  }, []);

  const getLeaveSettingByYears = async (year) => {
    try {
      const url = baseURL + "/api/leaveSetting/datatable";
      const params = new URLSearchParams({
        page: 1,
        size: 10,
        "order[0]": "budget_year",
        "order[1]": "DESC",
        "filter[budget_year][0]": year,
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      setBudgetYearData(res?.data?.result[0]);
    } catch (err) {
      console.error(err);
    }
  };

  const editLeaveSetting = async () => {
    try {
      let reqObj = {
        budget_year:budgetYearData.budget_year,
        sick_limit_day:budgetYearData.sick_limit_day,
        personal_limit_day:budgetYearData.personal_limit_day,
        maternity_limit_day:budgetYearData.maternity_limit_day,
        vacation_limit_day:budgetYearData.vacation_limit_day,
        vacation_under10:budgetYearData.vacation_under10,
        vacation_over10:budgetYearData.vacation_over10,
        abroad_limit_day:budgetYearData.abroad_limit_day,
        ordinate_limit_day:budgetYearData.ordinate_limit_day,
        hajj_limit_day:budgetYearData.hajj_limit_day,
        conscription_limit_day:budgetYearData.conscription_limit_day,
        training_limit_day:budgetYearData.training_limit_day,
        spouse_limit_day:budgetYearData.spouse_limit_day,
        outside_limit_day:budgetYearData.outside_limit_day,
        practice_limit_day:budgetYearData.practice_limit_day,
        status:budgetYearData.status,
        approved_name: '',
        approved_position: '',
        approved_org: '',
        approved_id: '',
        parenting_limit_day:budgetYearData.parenting_limit_day,
        helpparenting_limit_day:budgetYearData.helpparenting_limit_day,
        rehabilitation_limit_day:budgetYearData.rehabilitation_limit_day
      };
      for (let key in reqObj) {
        if (reqObj[key] === null) {
            delete reqObj[key];
        }
      }
      let res;
      res = await axios.put(
        baseURL + `/api/leaveSetting/${budgetYear}`,
        reqObj,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      res && setSuccessAdd(true)
    } catch (err) {
      setFailAdd(true)
      console.error(err);
    }
  };

  useEffect(() => {
    if (budgetYear) getLeaveSettingByYears(budgetYear);
    setTimeout(() => {
      setLoading(false);
    }, 700);
  }, [budgetYear]);

  useEffect(() => {
    successAdd && getLeaveSettingByYears(budgetYear)
  }, [successAdd])
  
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleAddLeaveSetting = async () => {
    setLoading(true);
    const dataLastYear = data.reduce((max, x) => {
      return x.budget_year > max.budget_year ? x : max;
    }, data[0]);
  
    const newYear = Number(dataLastYear.budget_year) + 1;
  
    try {
      let newData = {
        budget_year: newYear,
        sick_limit_day: budgetYearData.sick_limit_day,
        personal_limit_day: budgetYearData.personal_limit_day,
        maternity_limit_day: budgetYearData.maternity_limit_day,
        vacation_limit_day: budgetYearData.vacation_limit_day,
        vacation_under10: budgetYearData.vacation_under10,
        vacation_over10: budgetYearData.vacation_over10,
        abroad_limit_day: budgetYearData.abroad_limit_day,
        ordinate_limit_day: budgetYearData.ordinate_limit_day,
        hajj_limit_day: budgetYearData.hajj_limit_day,
        conscription_limit_day: budgetYearData.conscription_limit_day,
        training_limit_day: budgetYearData.training_limit_day,
        spouse_limit_day: budgetYearData.spouse_limit_day,
        outside_limit_day: budgetYearData.outside_limit_day,
        practice_limit_day: budgetYearData.practice_limit_day,
        status: budgetYearData.status,
        approved_name: '',
        approved_position: '',
        approved_org: '',
        approved_id: '',
        parenting_limit_day: budgetYearData.parenting_limit_day,
        helpparenting_limit_day: budgetYearData.helpparenting_limit_day,
        rehabilitation_limit_day: budgetYearData.rehabilitation_limit_day,
      };
  
      // ลบ key ที่ null
      for (let key in newData) {
        if (newData[key] === null) {
          delete newData[key];
        }
      }
  
      const res = await axios.post(
        baseURL + `/api/leaveSetting/save`,
        newData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      if (res) {
        // refresh ข้อมูลใหม่
        await getLeaveSetting();
  
        // set ปีล่าสุดเป็นปีที่เพิ่งเพิ่ม
        setBudgetYear(newYear);
  
        // โหลดข้อมูลปีล่าสุด
        await getLeaveSettingByYears(newYear);
  
        setSuccessAdd(true);
      }
    } catch (err) {
      setFailAdd(true);
      console.error(err);
    }
    setLoading(false);
  };
  

  return (
    <FadeIn>
      <SubMenuLeave menu={1} />
      <Breadcrumb
        title="หน้าหลัก"
        breadcrumbItem="การลาออนไลน์"
        isBack={true}
        isSubMenu={true}
        subMenuName="กำหนดข้อมูลวันลา"
        path="/leave"
      />
      <Card>
        <CardBody className="pb-2">
          <CardTitle>กำหนดข้อมูลวันลา</CardTitle>
          <Form>
            <FormGroup row>
              <Label className="text-end" xs={3} xxl={2} xl={3}>
                ปีงบประมาณ
              </Label>
              <Col xs={9} xxl={2} xl={9}>
                <Input
                  type="select"
                  defaultValue={budgetYear}
                  onChange={(e) => {
                    setBudgetYear(e.target.value);
                    setLoading(true);
                  }}
                >
                  {data?.map((item) => {
                    return (
                      <option key={item.budget_year} value={item?.budget_year}>
                        {item?.budget_year}
                      </option>
                    );
                  })}
                </Input>
                
              </Col>
              <Col xs={9} xxl={2} xl={9}>
                <Button
                  color="primary"
                  onClick={handleAddLeaveSetting}
                >
                  <i className="fa-solid fa-plus me-2"></i>เพิ่ม
                </Button>
              </Col>
            </FormGroup>
            {loading === true ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: "700px",
                }}
              >
                <LoadingData />
              </div>
            ) : (
              <FadeIn>
                <FormGroup row>
                  <Col xs={12} xxl={5} xl={12} className="mt-3">
                    <Row>
                      <Label xxl={6} xl={3} xs={3} className="text-end">
                        ลาป่วย
                      </Label>
                      <Col xs={9} xxl={6} xl={9}>
                        <InputGroup>
                          <Input
                            type="number"
                            value={budgetYearData.sick_limit_day}
                            onChange={(e) => {
                              setBudgetYearData((prev) => ({
                                ...prev,
                                sick_limit_day : e.target.value
                              }));
                            }}
                          />
                          <InputGroupText>วัน</InputGroupText>
                        </InputGroup>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={12} xxl={7} xl={12} className="mt-3">
                    <Row>
                      <Label className={`${windowSize.width < 1200 ? "text-start" : "text-end"}`} xs={12} xxl={3} xl={3}>
                        ลาพักผ่อน :{" "}
                      </Label>
                      <Label className="text-end" xs={3} xxl={3} xl={3}>
                        ได้วันลาพักผ่อนปีละ
                      </Label>
                      <Col xs={9} xxl={4} xl={6}>
                        <InputGroup>
                          <Input
                            type="number"
                            value={budgetYearData?.vacation_limit_day}
                            onChange={(e) => {
                              setBudgetYearData((prev) => ({
                                ...prev,
                                vacation_limit_day : e.target.value
                              }));
                            }}
                          />
                          <InputGroupText>วัน</InputGroupText>
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className="mt-3">
                      <Col xs={12} xxl={1} xl={3}></Col>
                      <Label className="text-end" xs={3} xxl={5} xl={3}>
                        อายุราชการ ไม่ถึง 10 ปี สะสมได้ไม่เกิน
                      </Label>
                      <Col xs={9} xxl={4} xl={6}>
                        <InputGroup>
                          <Input
                            type="number"
                            value={budgetYearData?.vacation_under10}
                            onChange={(e) => {
                              setBudgetYearData((prev) => ({
                                ...prev,
                                vacation_under10 : e.target.value
                              }));
                            }}
                          />
                          <InputGroupText>วัน</InputGroupText>
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className="mt-3">
                      <Col xs={12} xxl={1} xl={3}></Col>
                      <Label className="text-end" xs={3} xxl={5} xl={3}>
                        อายุราชการ เกิน 10 ปี สะสมได้ไม่เกิน{" "}
                      </Label>
                      <Col xs={9} xxl={4} xl={6}>
                        <InputGroup>
                          <Input
                            type="number"
                            value={budgetYearData?.vacation_over10}
                            onChange={(e) => {
                              setBudgetYearData((prev) => ({
                                ...prev,
                                vacation_over10 : e.target.value
                              }));
                            }}
                          />
                          <InputGroupText>วัน</InputGroupText>
                        </InputGroup>
                      </Col>
                    </Row>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Col xs={12} xxl={5} xl={12} className="mt-3">
                    <Row>
                      <Label className="text-end" xs={3} xxl={6} xl={3}>
                        ลากิจส่วนตัว
                      </Label>
                      <Col xs={9} xxl={6} xl={9}>
                        <InputGroup>
                          <Input
                            type="number"
                            value={budgetYearData?.personal_limit_day}
                            onChange={(e) => {
                              setBudgetYearData((prev) => ({
                                ...prev,
                                personal_limit_day : e.target.value
                              }));
                            }}
                          />
                          <InputGroupText>วัน</InputGroupText>
                        </InputGroup>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={12} xxl={7} xl={12} className="mt-3">
                    <Row>
                      <Label className="text-end" xs={3} xxl={4} xl={3}>
                        ลาไปปฏิบัติราชการ
                      </Label>
                      <Col xs={9} xxl={4} xl={9}>
                        <InputGroup>
                          <Input
                            type="number"
                            value={budgetYearData?.outside_limit_day}
                            onChange={(e) => {
                              setBudgetYearData((prev) => ({
                                ...prev,
                                outside_limit_day : e.target.value
                              }));
                            }}
                          />
                          <InputGroupText>วัน</InputGroupText>
                        </InputGroup>
                      </Col>
                    </Row>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Col xs={12} xxl={5} xl={12} className="mt-3">
                    <Row>
                      <Label className="text-end" xs={3} xxl={6} xl={3}>
                        ลาคลอดบุตร
                      </Label>
                      <Col xs={9} xxl={6} xl={9}>
                        <InputGroup>
                          <Input
                            type="number"
                            value={budgetYearData?.maternity_limit_day}
                            onChange={(e) => {
                              setBudgetYearData((prev) => ({
                                ...prev,
                                maternity_limit_day : e.target.value
                              }));
                            }}
                          />
                          <InputGroupText>วัน</InputGroupText>
                        </InputGroup>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={12} xxl={7} xl={12} className="mt-3">
                    <Row>
                      <Label className="text-end" xs={3} xxl={4} xl={3}>
                        รับรองการมาปฏิบัติราชการ
                      </Label>
                      <Col xs={9} xxl={4} xl={9}>
                        <InputGroup>
                          <Input
                            type="number"
                            value={budgetYearData?.practice_limit_day}
                            onChange={(e) => {
                              setBudgetYearData((prev) => ({
                                ...prev,
                                practice_limit_day : e.target.value
                              }));
                            }}
                          />
                          <InputGroupText>วัน</InputGroupText>
                        </InputGroup>
                      </Col>
                    </Row>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Col xs={12} xxl={5} xl={12} className="mt-3">
                    <Row>
                      <Label className="text-end" xs={3} xxl={6} xl={3}>
                        ลาไปต่างประเทศ
                      </Label>
                      <Col xs={9} xxl={6} xl={9}>
                        <InputGroup>
                          <Input
                            type="number"
                            value={budgetYearData.abroad_limit_day}
                            onChange={(e) => {
                              setBudgetYearData((prev) => ({
                                ...prev,
                                abroad_limit_day : e.target.value
                              }));
                            }}
                          />
                          <InputGroupText>วัน</InputGroupText>
                        </InputGroup>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={12} xxl={7} xl={12} className="mt-3">
                    <Row>
                      <Label className="text-end" xs={3} xxl={4} xl={3}>
                        ลากิจส่วนตัวเพื่อเลี้ยงดูบุตร
                      </Label>
                      <Col xs={9} xxl={4} xl={9}>
                        <InputGroup>
                          <Input
                            type="number"
                            value={budgetYearData?.parenting_limit_day}
                            onChange={(e) => {
                              setBudgetYearData((prev) => ({
                                ...prev,
                                parenting_limit_day : e.target.value
                              }));
                            }}
                          />
                          <InputGroupText>วัน</InputGroupText>
                        </InputGroup>
                      </Col>
                    </Row>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Col xs={12} xxl={5} xl={12} className="mt-3">
                    <Row>
                      <Label className="text-end" xs={3} xxl={6} xl={3}>
                        ลาอุปสมบท
                      </Label>
                      <Col xs={9} xxl={6} xl={9}>
                        <InputGroup>
                          <Input
                            type="number"
                            value={budgetYearData?.ordinate_limit_day}
                            onChange={(e) => {
                              setBudgetYearData((prev) => ({
                                ...prev,
                                ordinate_limit_day : e.target.value
                              }));
                            }}
                          />
                          <InputGroupText>วัน</InputGroupText>
                        </InputGroup>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={12} xxl={7} xl={12} className="mt-3">
                    <Row>
                      <Label className="text-end" xs={3} xxl={4} xl={3}>
                        ลาไปช่วยเหลือภริยาที่คลอดบุตร
                      </Label>
                      <Col xs={9} xxl={4} xl={9}>
                        <InputGroup>
                          <Input
                            type="number"
                            value={budgetYearData?.helpparenting_limit_day}
                            onChange={(e) => {
                              setBudgetYearData((prev) => ({
                                ...prev,
                                helpparenting_limit_day : e.target.value
                              }));
                            }}
                          />
                          <InputGroupText>วัน</InputGroupText>
                        </InputGroup>
                      </Col>
                    </Row>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Col xs={12} xxl={5} xl={12} className="mt-3">
                    <Row>
                      <Label className="text-end" xs={3} xxl={6} xl={3}>
                        ลาไปพิธีฮัจญ์
                      </Label>
                      <Col xs={9} xxl={6} xl={9}>
                        <InputGroup>
                          <Input
                            type="number"
                            value={budgetYearData?.hajj_limit_day}
                            onChange={(e) => {
                              setBudgetYearData((prev) => ({
                                ...prev,
                                hajj_limit_day : e.target.value
                              }));
                            }}
                          />
                          <InputGroupText>วัน</InputGroupText>
                        </InputGroup>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={12} xxl={7} xl={12} className="mt-3">
                    <Row>
                      <Label className="text-end" xs={3} xxl={4} xl={3}>
                        ลาไปฟื้นฟูสมรรถภาพด้านอาชีพ
                      </Label>
                      <Col xs={9} xxl={4} xl={9}>
                        <InputGroup>
                          <Input
                            type="number"
                            value={budgetYearData?.rehabilitation_limit_day}
                            onChange={(e) => {
                              setBudgetYearData((prev) => ({
                                ...prev,
                                rehabilitation_limit_day : e.target.value
                              }));
                            }}
                          />
                          <InputGroupText>วัน</InputGroupText>
                        </InputGroup>
                      </Col>
                    </Row>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Col xs={12} xxl={5} xl={12} className="mt-3">
                    <Row>
                      <Label className="text-end" xs={3} xxl={6} xl={3}>
                        เข้าตรวจเลือก/เตรียมพล
                      </Label>
                      <Col xs={9} xxl={6} xl={9}>
                        <InputGroup>
                          <Input
                            type="number"
                            value={budgetYearData?.conscription_limit_day}
                            onChange={(e) => {
                              setBudgetYearData((prev) => ({
                                ...prev,
                                conscription_limit_day : e.target.value
                              }));
                            }}
                          />
                          <InputGroupText>วัน</InputGroupText>
                        </InputGroup>
                      </Col>
                    </Row>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Col xs={12} xxl={5} xl={12} className="mt-3">
                    <Row>
                      <Label className="text-end" xs={3} xxl={6} xl={3}>
                        ลาศึกษาต่อ
                      </Label>
                      <Col xs={9} xxl={6} xl={9}>
                        <InputGroup>
                          <Input
                            type="number"
                            value={budgetYearData?.training_limit_day}
                            onChange={(e) => {
                              setBudgetYearData((prev) => ({
                                ...prev,
                                training_limit_day : e.target.value
                              }));
                            }}
                          />
                          <InputGroupText>วัน</InputGroupText>
                        </InputGroup>
                      </Col>
                    </Row>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Col xs={12} xxl={5} xl={12} className="mt-3">
                    <Row>
                      <Label className="text-end" xs={3} xxl={6} xl={3}>
                        ลาติดตามคู่สมรส
                      </Label>
                      <Col xs={9} xxl={6} xl={9}>
                        <InputGroup>
                          <Input
                            type="number"
                            value={budgetYearData?.spouse_limit_day}
                            onChange={(e) => {
                              setBudgetYearData((prev) => ({
                                ...prev,
                                spouse_limit_day : e.target.value
                              }));
                            }}
                          />
                          <InputGroupText>วัน</InputGroupText>
                        </InputGroup>
                      </Col>
                    </Row>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Col xs={12} xxl={6} xl={12} className="mt-3">
                    {/* <Row>
                      <Label className="text-end" xs={3} xxl={5} xl={3}>
                        กำหนดเจ้าหน้าที่
                      </Label>
                      <Col xs={9} xxl={7} xl={9}>
                      <InputGroup>
                        <Input
                          readOnly
                          defaultValue={userName}
                          name="user_name"
                          placeholder=""
                          type="text"
                        />
                        <ModalUser task="user_ผู้บังคับบัญชา" showSelectedAllMenu={true}/>
                      </InputGroup>
                      </Col>
                    </Row> */}
                  </Col>
                  <Col xs={12} xxl={5} xl={12} className="mt-3">
                    <Row className="d-flex justify-content-end">
                      <Col xs={12} xl={3}></Col>
                      <Col xs={12} xxl={6} xl={9}>
                        <Button className="w-75" color="success"
                          onClick={() => {
                            editLeaveSetting()
                          }}
                        >
                          บันทึก
                        </Button>
                      </Col>
                    </Row>
                    <Row className="d-flex justify-content-end pt-3 me-5 pe-4">
                <Toast className="align-items-center text-white bg-success border-0 mb-2 shadow-none"
                  isOpen={successAdd} role="alert" aria-label="assertive" aria-atomic={true} >
                  <ToastBody className="d-flex">
                    <i class="fa-solid fa-circle-check m-0 mt-1 me-2"></i>
                      บันทึกสำเร็จ
                    <button onClick={() => setSuccessAdd(false)} type="button" class="btn-close btn-close-white me-0 m-auto" />
                </ToastBody>
                </Toast>
                </Row>
                <Row className="d-flex justify-content-end pt-3 me-5 pe-4">
                <Toast className="align-items-center text-white bg-danger border-0 mb-2 shadow-none"
                  isOpen={failAdd} role="alert" aria-label="assertive" aria-atomic={true} >
                  <ToastBody className="d-flex">
                    <i class="fa-solid fa-circle-check m-0 mt-1 me-2"></i>
                    บันทึกไม่สำเร็จ
                    <button onClick={() => setFailAdd(false)} type="button" class="btn-close btn-close-white me-0 m-auto" />
                  </ToastBody>
                </Toast>
                </Row>
                  </Col>
                </FormGroup>
              </FadeIn>
            )}
          </Form>
        </CardBody>
      </Card>
    </FadeIn>
  );
};

export default Menu1;
